/* eslint-disable @nrwl/nx/enforce-module-boundaries */
import { Error, ErrorIcon, ErrorTitle, ErrorDescription, ErrorCTA, Button } from '@quadminds/mindkit';
import IconDark from '@quadminds/mindy-app/assets/img/errors/SearchDark.svg';
import IconLight from '@quadminds/mindy-app/assets/img/errors/SearchLight.svg';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function PageNotFound() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <Error>
            <ErrorIcon>
                <img src={IconLight} alt="Error" className="dark:hidden h-24 w-auto" />
                <img src={IconDark} alt="Error" className="hidden dark:block h-24 w-auto" />
            </ErrorIcon>
            <ErrorTitle>{t('errors.pageNotFound')}</ErrorTitle>
            <ErrorDescription>
                <p className="max-w-96">{t('errors.pageNotFoundDescription')}</p>
            </ErrorDescription>
            <ErrorCTA>
                <Button onClick={() => navigate('/chat')}>{t('errors.pageNotFoundCTA')}</Button>
            </ErrorCTA>
        </Error>
    );
}

export default PageNotFound;
